<script lang="ts">
  import { createEventDispatcher, getContext, onMount } from "svelte"
  import type { Settings } from "website_script/types/settings"

  const dispatch = createEventDispatcher()

  const { contactPageUrl, openContactPageInNewTab }: Settings =
    getContext("settings")

  onMount(() => {
    dispatch("flowEvent", {
      action: "completeFlow",
      data: null,
    })
    const whereToOpen = openContactPageInNewTab ? "_blank" : "_self"
    window.open(contactPageUrl, whereToOpen)
  })
</script>
